// import styles from "./style.module.scss";
import React, { useState, useEffect } from 'react';
import { STATISTICS_API } from '../../api-handle';
import PageHeading from '../../components/PageHeading';
import { LOCALSTORAGE_TOKEN_LABEL } from '../../constants';
import Chart from 'react-apexcharts';

/**
 * Statistics component:
 * - display all the current statistics through charts and visualizations
 */

const CHART_SETUPS_MAP = {
  '24 Hours': 'daily',
  Weekly: 'weekly',
  Monthly: 'monthly',
  'Half Yearly': 'half-yearly',
  Yearly: 'yearly',
};

const CHART_SETUPS = Object.keys(CHART_SETUPS_MAP);

export default function Statistics() {
  const [isLoading, setIsLoading] = useState(true);
  const [curChartSetup, setCurChartSetup] = useState(
    CHART_SETUPS_MAP[CHART_SETUPS[0]]
  );
  const [deviceEventChart, setDeviceEventChart] = useState(null);
  const [catEventChart, setCatEventChart] = useState(null);

  useEffect(() => {
    (async () => {
      setIsLoading(true);

      let res = await STATISTICS_API.getEventByClass(
        localStorage.getItem(LOCALSTORAGE_TOKEN_LABEL),
        null,
        curChartSetup
      );

      let timeSeries = [];
      let eventSeries = [];
      let categories = [];

      if (res && res.data.length > 0) {
        timeSeries = Object.keys(res.data[0].statistics);
        let tempData_ = [];
        res.data.forEach((i) => {
          tempData_.push({
            name: i.device.name,
            data: Object.values(i.statistics).map((j) =>
              j.map((k) => k.count).reduce((a, b) => a + b, 0)
            ),
          });
          // add all current category names to the categories array
          categories = [
            ...categories,
            ...new Set(
              Object.values(i.statistics)
                .flat(2)
                .map((_) => _.className)
            ),
          ];
        });
        eventSeries = tempData_;
      }

      let catDict = {};
      categories.forEach((c) => {
        catDict[c] = {};
        Object.keys(res.data[0].statistics).forEach((k) => {
          catDict[c][k] = 0;
        });
      });

      setDeviceEventChart({
        timeSeries: timeSeries,
        eventSeries: eventSeries,
      });

      if (res && res.data.length > 0) {
        timeSeries = Object.keys(res.data[0].statistics);
        res.data.forEach((i) => {
          if (Object.values(i.statistics)) {
            Object.keys(i.statistics).forEach((j) => {
              if (j.length > 0) {
                i.statistics[j].forEach((k) => {
                  catDict[k.className][j] += k.count;
                });
              }
            });
          }
        });
      }
      
      eventSeries = [];

      Object.keys(catDict).forEach(c=>{
        eventSeries.push({
          name:c,
          data: Object.values(catDict[c])
        })
      })
      
      console.log(eventSeries);
      setCatEventChart({
        timeSeries: timeSeries,
        eventSeries: eventSeries,
      });

      setIsLoading(false);
    })();
  }, [curChartSetup]);

  return (
    <div className="container">
      <div className="bg-white rounded-15 shadow-sm px-3">
        <PageHeading title="Statistics" />

        {isLoading ? (
          <div className="py-5 d-flex flex-column align-items-center">
            <div className="d-flex justify-content-center gap-1">
              <div
                className="spinner-grow spinner-grow-sm text-primary"
                role="status"
              ></div>
              <div
                className="spinner-grow spinner-grow-sm text-primary"
                role="status"
              ></div>
              <div
                className="spinner-grow spinner-grow-sm text-primary"
                role="status"
              ></div>
            </div>
            <br />
            <div className="fw-bold text-primary">Loading data...</div>
          </div>
        ) : (
          <>
            <div className="row justify-content-between">
              <div className="col-12 col-md-3 my-3">
                <div className="fs-4">Events by Devices</div>
              </div>
              <div className="col-12 col-md-3 my-3">
                <select
                  className="form-select"
                  onChange={(e) => setCurChartSetup(e.target.value)}
                >
                  {CHART_SETUPS.map((i) => (
                    <option value={CHART_SETUPS_MAP[i]}>{i}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="row">
              {['line', 'bar'].map((__chart, idx) => (
                <div className="col-12 col-md-6" key={idx}>
                  <Chart
                    options={{
                      stroke: {
                        width: 5,
                      },
                      xaxis: {
                        categories: deviceEventChart.timeSeries,
                        title: {
                          text: 'Time',
                          style: {
                            fontFamily: 'Poppins, sans-serif',
                          },
                        },
                      },
                      yaxis: {
                        title: {
                          text: 'Frequency',
                          style: {
                            fontFamily: 'Poppins, sans-serif',
                          },
                        },
                      },
                      chart: {
                        stacked: true,
                      },
                    }}
                    series={deviceEventChart.eventSeries}
                    type={__chart}
                    height="450"
                  />
                </div>
              ))}
            </div>
            <br />
            <div className="fs-4">Events by Categories</div>
            <div className="row">
              {['line', 'bar'].map((__chart, idx) => (
                <div className="col-12 col-md-6" key={idx}>
                  <Chart
                    options={{
                      stroke: {
                        width: 5,
                      },
                      xaxis: {
                        categories: catEventChart.timeSeries,
                        title: {
                          text: 'Time',
                          style: {
                            fontFamily: 'Poppins, sans-serif',
                          },
                        },
                      },
                      yaxis: {
                        title: {
                          text: 'Frequency',
                          style: {
                            fontFamily: 'Poppins, sans-serif',
                          },
                        },
                      },
                      chart: {
                        stacked: true,
                      },
                    }}
                    series={catEventChart.eventSeries}
                    type={__chart}
                    height="450"
                  />
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
